

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { securityRolesHead } from "../../../../../config/constant";
import { Link, NavLink } from "react-router-dom";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import clsx from "clsx";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';

export const ListTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, onDelete, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;

    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={securityRolesHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow
                                                key={i}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(securityRolesHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Security Roles', 'view', 'Younote Admin') ?
                                                            <Link style={{ width: getColumnWidth(securityRolesHead, 0) }} to={`/younote-admin/security-setup/security-roles/${data.id}/view`} className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.PaddingRight50, classes.disBlock, classes.bold)}>
                                                                {data.name}</Link> : <span style={{ width: getColumnWidth(securityRolesHead, 0) }}>{data.name}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(securityRolesHead, 1) }}><span style={{ width: getColumnWidth(securityRolesHead, 1) }}>{data?.mappedFeatures || 0}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(securityRolesHead, 2) }}><span style={{ width: getColumnWidth(securityRolesHead, 2) }}>{data?.mappedUsers || 0}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(securityRolesHead, 3) }}><span style={{ width: getColumnWidth(securityRolesHead, 3) }}>{data?.mappedclients || 0}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center"  size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Security Roles', 'view', 'Younote Admin') &&
                                                            <Link to={`/younote-admin/security-setup/security-roles/${data.id}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Security Roles', 'edit', 'Younote Admin') &&
                                                            <Link to={`/younote-admin/security-setup/security-roles/${data.id}/edit`}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Security Roles', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell className={classes.textAlignCenter} colSpan={6}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}